import InspectionsIcon from './InspectionsIcon';
import CogIcon from './Cog/Cog';
const map = {
    inspections: InspectionsIcon,
    cog: CogIcon,
};
const DynamicIcon = (props) => map[props.icon](props);
export default DynamicIcon;
